<template>
  <div class="wrapper">
    <div class="photo-container" :key="componentKey">
      <div class="position-compare" v-if="situation && situation.media">
        <img :src="`/demo/photo/compare/${leftGlasses}.jpg`" class="photo-left" />
        <img :src="`/demo/photo/compare/${rightGlasses}.jpg`" class="photo-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoCompareMode',
  data() {
    return {
      componentKey: 0,
    };
  },
  computed: {
    //get the current situation
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    rightGlasses() {
      return this.$parent.RightSelectedValue.id;
    },
    leftGlasses() {
      return this.$parent.LeftSelectedValue.id;
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
}

.photo-container {
  margin: auto;
  position: relative;
}

.photo-left {
  width: 50%;
}

.photo-right {
  width: 50%;
}

.position-compare {
  display: flex;
}

@media only screen and (device-width: 768px) {
  .position-compare {
    display: inline-block;
  }
}
</style>
